import type { BreakdownControlProps } from 'features/charts-v2/components/BreakdownControl'
import type {
  ChartSectionProps,
  ControlsSidebarSection,
} from 'features/charts-v2/components/ControlsSidebar/ControlsSidebar'
import type { FilterControlProps } from 'features/charts-v2/components/FilterControl'
import type { MetricControlProps } from 'features/charts-v2/components/MetricControl'

interface SectionProps {
  chart?: ChartSectionProps
  metric?: MetricControlProps
  breakdown?: BreakdownControlProps
  filter?: FilterControlProps
}

/**
 * Enforces the one-way "declared ⇒ prop present" contract every
 * `ControlsSidebar` caller must satisfy — a page that lists a built-in
 * section in `sections` must also pass that section's prop bag.
 */
export function assertSectionsSatisfied(
  sections: readonly ControlsSidebarSection[],
  { chart, metric, breakdown, filter }: SectionProps,
): void {
  if (sections.includes('chart') && !chart) {
    throw new Error(
      "ControlsSidebar: sections includes 'chart' but no `chart` prop was given",
    )
  }
  if (sections.includes('metric') && !metric) {
    throw new Error(
      "ControlsSidebar: sections includes 'metric' but no `metric` prop was given",
    )
  }
  if (sections.includes('breakdown') && !breakdown) {
    throw new Error(
      "ControlsSidebar: sections includes 'breakdown' but no `breakdown` prop was given",
    )
  }
  if (sections.includes('filter') && !filter) {
    throw new Error(
      "ControlsSidebar: sections includes 'filter' but no `filter` prop was given",
    )
  }
}
